import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import RelevantItemsTabState from './RelevantItemsTabState';
import RelevantItemsView from './RelevantItemsView';

export default class RelevantItemsTabView extends BufferTabView<RelevantItemsTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    this.listenTo(this.model, 'change', () => {
      this.render();
    });
  }

  override render(): this {
    const model = this.model.get('model');
    this.reactRoot = ReduxDOMRender.renderToDOM(
      <RelevantItemsView fileId={model.id} />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    ReduxDOMRender.unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

RelevantItemsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
